module.exports = __webpack_public_path__ + "static/favicon.15e6d78c.ico";


//////////////////
// WEBPACK FOOTER
// /Users/stephan/skelware/savot/public/images/favicon.ico
// module id = 497
// module chunks = 0 1